module.exports = __webpack_public_path__ + "static/giant_slayer-7a0148403808fe1bd6d4340e2e15c87f.jpeg";